import Icon from '../Icon'
import CircleLoader from '../CircleLoader'
import { withRouter } from 'i18n/utils'
import { components } from 'react-select'
import { getUserLocation, setActiveSearchLocation } from 'map/actions'

const NearMe = ({ getUserLocation, setActiveSearchLocation, history, ...props }) => {
    const [error, setError] = React.useState(true)
    const [isLoading, setIsLoading] = React.useState(false)

    React.useEffect(() => {
        handlePermission()
    }, [])

    const handlePermission = () => {
        if (
            typeof localStorage['authorizedGeoLocation'] === 'undefined' ||
            localStorage['authorizedGeoLocation'] === '1'
        ) {
            setError(false)
        }
    }

    const getUserLocationHandler = () => {
        if (navigator.geolocation) {
            setIsLoading(true)

            navigator.geolocation.getCurrentPosition(position => {
                const lat = position.coords.latitude
                const lng = position.coords.longitude

                getUserLocation({
                    lat,
                    lng,
                })
                setActiveSearchLocation({ lat, lng })

                localStorage['authorizedGeoLocation'] = 1
                setIsLoading(false)
                history.push('/map')
            }, showError)
        }
    }

    const showError = error => {
        if (error) {
            localStorage['authorizedGeoLocation'] = 0
            setError(true)
            setIsLoading(false)
        }
    }

    return (
        <components.MenuList {...props}>
            {error ? null : (
                <div onClick={getUserLocationHandler} className="option select__near-me-location">
                    <div className="option__icon">
                        <Icon type="target" size="xs" />
                    </div>
                    <div className="option__text">
                        <p>
                            <T>input.placeholder.near.me</T>
                        </p>
                    </div>
                    {isLoading && <CircleLoader className="ml-auto" size="small" />}
                </div>
            )}

            {props.children}
        </components.MenuList>
    )
}

export default compose(withRouter, connect(null, { getUserLocation, setActiveSearchLocation }))(NearMe)
